/**
 * Auth Module
 */
import Vue from 'vue';
import Nprogress from 'nprogress';
import router from '../../../router';
import axios from 'axios';

import laravelEcho from '../../../lib/laravel-echo'
// state
const token = localStorage.getItem('access_token')

if (token) {
  laravelEcho(token)
}

const state = {
  user: null,
  access_token: localStorage.getItem('access_token'),
};

// getters
const getters = {
  getUser: state => state.user,
  getAccessToken: state => state.access_token,
  isAuthenticated: state => state.user !== null,
  isUserSigninWithAuth0: state => state.isUserSigninWithAuth0,
};

// actions
const actions = {
  async signinUserInDatabase(context, payload) {
    const {user} = payload;
    const {email, password} = user;
    context.commit('loginUser');
    try {
      const { data } = await axios.post('/admin-login', {email, password});
      context.commit('loginUserSuccess', data);
      await context.dispatch('fetchUser')
      router.push('/default/dashboard');
      Nprogress.done();
    } catch ({status, data}) {
      Nprogress.done();
      if (status == 422) {
        context.commit('loginUserFailure', data.errors.email[0]);
      }
    }
  },
  async fetchUser(context) {
    try {
      Nprogress.start();
      const {data} = await axios.get('user');
      state.user = data;
      return data;
    } catch (e) {
      context.commit('loginUserFailure', 'Oturum sureniz dolmus olabilir.');
      return false;
    }
  },
  async logout(context) {
    try {
      Nprogress.start();
      await api.post('auth/logout');
      context.commit('logoutUser');
      Nprogress.done();
    } catch (e) {
    }
  },
  updateUser(context, payload) {
    context.commit('updateUser', payload);
  },
  logoutUserFromFirebase(context) {
    context.commit('logoutUser');
  },
  signOutUserFromAuth0(context) {
    context.commit('signOutUserFromAuth0Success');
  },
};

// mutations
const mutations = {
  loginUser(state) {
    Nprogress.start();
  },
  loginUserSuccess(state, user) {
    state.access_token = user.token;
    localStorage.setItem('access_token', user.token);
    laravelEcho(user.token)

    setTimeout(function() {
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: 'Başarılı şekilde giriş yaptiniz!',
      });
    }, 1500);
  },
  loginUserFailure(state, error) {
    Nprogress.done();
    Vue.notify({
      group: 'loggedIn',
      type: 'error',
      text: error,
    });
  },
  logoutUser(state) {
    state.user = null;
    localStorage.removeItem('access_token');
    window.localStorage.clear();
    router.push('/session/login');
  },
  updateUser(state, user) {
    state.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
